import {Call, CallStatus} from '@/core/models/call';
import {DeclaredInterestCall} from '../model/types';

/**
 * Converts a DeclaredInterestCall to a Call object for use with CallCard component
 */
export const adaptDeclaredInterestCallToCall = (declaredCall: DeclaredInterestCall): Call => {
  // Parse budget string (e.g., "1000000" -> 1000000)
  const amount = declaredCall.budget ? parseInt(declaredCall.budget, 10) : 0;

  // Map type to CallStatus
  const mapTypeToStatus = (type: string): CallStatus => {
    switch (type.toLowerCase()) {
      case 'active':
        return CallStatus.ACTIVE;
      case 'closed':
        return CallStatus.CLOSED;
      case 'draft':
        return CallStatus.DRAFT;
      case 'suspended':
        return CallStatus.SUSPENDED;
      default:
        return CallStatus.ACTIVE; // Default for calls
    }
  };

  return {
    id: declaredCall.id,
    createdAt: new Date().toISOString(), // Default since not available in DeclaredInterestCall
    updatedAt: new Date().toISOString(), // Default since not available in DeclaredInterestCall
    title: declaredCall.title,
    description: '', // DeclaredInterestCall doesn't have description
    amount: amount,
    currency: 'EUR', // Default currency since it's not in DeclaredInterestCall
    deadline: declaredCall.deadline,
    is_new: declaredCall.is_new,
    status: mapTypeToStatus(declaredCall.type),
    categories: declaredCall.sectors?.map((sector) => sector.name) || [],
    requirements: [], // DeclaredInterestCall doesn't have requirements
    interested_partners: declaredCall.interested_partners,
    programme: declaredCall.programme,
    matchPercentage: 0, // DeclaredInterestCall doesn't have match percentage
    comments: declaredCall.comments_count,
    ideas: declaredCall.ideas_count,
    tags: [], // DeclaredInterestCall doesn't have tags
    is_call_bookmarked: declaredCall.is_call_bookmarked, // Default since not available in DeclaredInterestCall
    is_call_declared_interest: declaredCall.is_call_declared_interest, // This is a declared interest call
  };
};
